import React from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import Link from 'next/link';
import { colors } from '../common/Theme';

import Header from '../common/Header';
import Footer from '../common/Footer';
import Card from '../common/layout/Card.js';
import Button from '../common/elements/Button.js';
import Box from '../common/elements/Box.js';
import Tips from '../common/elements/Tips.js';
import { SUBSCRIBE_HREF } from '../../../pages/souscrire';
import { SIMULATION_HREF } from '../../../pages/assurance/simulation';

const desktopMaxWidth = '1150px';
const menuDesktopMinWidth = '900px';
const headerStyle = css.resolve`
  .header {
    position: relative;
    z-index: 200;
  }
`;

const bannerButtonStyle = css.resolve`
  .banner-button {
    width: 100%;
    max-width: 500px;
  }

  @media (min-width: ${menuDesktopMinWidth}) {
    .banner-button {
      min-width: 200px;
      margin-right: 24px;
    }
  }
`;
const contractCardStyle = css.resolve`
  .card {
    margin-left: auto;
    padding: 20px 40px;
    max-width: 460px;
    color: ${colors.ywgNavy};
  }

  @media (min-width: ${desktopMaxWidth}) {
    .card {
      padding: 60px 50px;
    }
  }
`;

const noticeCardStyle = css.resolve`
  .card {
    position: relative;
    margin: 24px 0;
    padding: 25px 20px;
    width: auto;
    text-align: center;
  }

  @media (min-width: ${desktopMaxWidth}) {
    .card {
      margin: 20px 0 -10px;
      padding-top: 0;
      width: 950px;
      flex-grow: 0;
      border-top-left-radius: 0;
    }

    .card:before {
      position: absolute;
      top: -30px;
      left: 0;
      width: 100%;
      height: 30px;
      content: '';
      background-color: white;
      border-top-left-radius: 30px;
      z-index: 10;
    }
  }
`;

const boxCardStyle = css.resolve`
  .card {
    margin-bottom: 20px;
    padding: 60px 10vw 40px;
  }

  .box-subtitle {
    margin: 0;
    color: ${colors.ywgNavy};
    text-align: center;
  }

  @media (min-width: ${desktopMaxWidth}) {
    .card {
      margin: 40px auto 40px;
      padding: 44px 100px;
      width: ${desktopMaxWidth};
    }

    .card-first {
      margin-top: -40px;
    }
  }
`;

const styles = css`
  .wrapper {
    color: ${colors.ywgNavyLight};
    line-height: 1.4;
  }

  .subscription-bottom {
    display: flex;
    flex-direction: column;
    margin: 0 24px 24px 24px;
    align-items: center;
  }
  @media (min-width: ${menuDesktopMinWidth}) {
    .subscription-bottom {
      flex-direction: row;
      justify-content: center;
    }
  }
  .text-emphasis {
    font-size: 1.2rem;
  }

  .card-container {
    z-index: 10;
  }

  .contract {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .contract-emphasis {
    margin-bottom: 30px;
  }

  .contract-zones-container {
    position: relative;
    padding: 50px 30px 80px;
    background-color: #e0e5e9;
    box-sizing: border-box;
  }

  .contract-zones-container:before {
    position: absolute;
    top: -30px;
    left: 0;
    width: 100%;
    height: 30px;
    content: '';
    background-color: #e0e5e9;
  }

  .contract-title {
    margin: 0 0 10px;
  }

  .contract-list {
    margin: 0;
    padding: 0;
  }

  .contract-list-item {
    font-size: 1.4rem;
    line-height: 2;
    list-style: none;
  }

  .contract-list-item::before {
    margin-right: 5px;
    content: '>';
    font-size: 1rem;
  }

  .contract-item-title {
    margin: 20px 0;
    color: ${colors.ywgNavy};
  }

  .contract-item-price {
    display: block;
  }

  .box-title {
    margin: 0 20px;
    color: ${colors.ywgNavy};
    text-align: center;
    text-transform: uppercase;
  }

  @media (min-width: ${desktopMaxWidth}) {
    .contract-item {
      width: 50%;
    }

    .contract-item-price {
      display: inline;
    }

    .contract-item-price::before {
      content: ' - ';
    }

    .contract-payment {
      margin: 12px 0;
    }

    .contract-zones-container:before {
      width: 30px;
      height: 100%;
      top: 0;
      left: -30px;
    }

    .container {
      margin-left: 0;
      margin-right: 0;
    }

    .card-container {
      margin-top: 100px;
    }

    .notice-container {
      display: flex;
      background-color: #e0e5e9;
      justify-content: center;
    }
  }
`;
const MEDICAL = 'frais-medicaux-etranger';
const MEDICAL_FRANCE = 'frais-medicaux-france';
const SUPPORT_RECOVERY = 'assistance-rapatriement';
const PUBLIC_LIABILITY = 'responsabilite-civile-etranger';
const LUGGAGES = 'perte-vol-deterioration-bagages';
const DEATH = 'capital-individuel-accident';
const AREA_A = 'area-details-a';
const AREA_B = 'area-details-b';
const AREA_C = 'area-details-c';
const cardItems = [
  {
    text: 'Frais médicaux à l’Étranger',
    id: MEDICAL,
    content: (
      <>
        <p className={classnames(boxCardStyle.className, 'box-subtitle')}>
          En cas d’hospitalisation, appel obligatoire au centre d’assistance
        </p>
        <Box
          icon="a"
          main={[
            {
              textStart: 'Max. zone A :',
              textStartHref: `#${AREA_A}`,
              textEnd: '80 000 €',
              type: 'important'
            },
            {
              textStart: 'Franchise par dossier :',
              textEnd: 'NÉANT'
            },
            {
              textStart: 'Consultation médicale :',
              textEnd: 'max. 50 €/acte'
            }
          ]}
          side={[
            'Prise en charge au 1 er euro ou remboursement, en complément d’un régime obligatoire, à concurrence de 100 % des frais réels.',
            'Prise en charge ou remboursement, à défaut d’un régime obligatoire, à concurrence de 75 % des frais réels.'
          ]}
        ></Box>
        <Box
          icon="b"
          main={[
            {
              textStart: 'Max. zone B :',
              textStartHref: `#${AREA_B}`,
              textEnd: '300 000 €',
              type: 'important'
            },
            {
              textStart: 'Franchise par dossier :',
              textEnd: '25 €'
            },
            {
              textStart: 'Consultation médicale :',
              textEnd: 'max. 100 €/acte'
            }
          ]}
          side={[
            'Prise en charge au 1 er euro ou remboursement, en complément d’un régime obligatoire, à concurrence de 100 % des frais réels.'
          ]}
        ></Box>
        <Box
          icon="c"
          main={[
            {
              textStart: 'Max. zone C :',
              textStartHref: `#${AREA_C}`,
              textEnd: '1 000 000 €',
              type: 'important'
            },
            {
              textStart: 'Franchise par dossier :',
              textEnd: '25 €'
            }
          ]}
          side={[
            'Prise en charge au 1 er euro ou remboursement, en complément d’un régime obligatoire, à concurrence de 100 % des frais réels.'
          ]}
        ></Box>
        <Box
          icon="tooth"
          main={[
            {
              textStart: "Soins dentaires d'urgence toutes zones",
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Max. :',
              textEnd: '300 €'
            },
            {
              textStart: 'Franchise par dossier :',
              textEnd: '25 €'
            }
          ]}
        ></Box>
      </>
    )
  },
  {
    text: 'Frais médicaux en France',
    id: MEDICAL_FRANCE,
    content: (
      <>
        <p className={classnames(boxCardStyle.className, 'box-subtitle')}>
          Les frais médicaux en France sont pris en charge dans le cadre de la
          continuité de soins après un rapatriement. Un retour temporaire d’un
          mois peut permettre la prise en charge de soins médicaux en France.
        </p>
        <Box
          icon="france"
          main={[
            {
              textStart: 'Max. en cas d’hospitalisation :',
              textEnd: '1 000 000 €',
              type: 'important'
            },
            {
              textStart: 'Max. hors hospitalisation :',
              textEnd: '15 000 €'
            },
            {
              textStart: 'Soins dentaires d’urgence :',
              textEnd: '300 €',
              type: 'important'
            },
            {
              textStart: 'Franchise par dossier :',
              textEnd: '25 €'
            }
          ]}
          side={[
            'Plafonnés sur la base et taux de remboursement de la Sécurité Sociale française',
            'Pas de franchise par dossier hospitalisation',
            'Pas de franchise par dossier hors hospitalisation'
          ]}
        ></Box>
      </>
    )
  },
  {
    text: 'Assistance - Rapatriement',
    id: SUPPORT_RECOVERY,
    content: (
      <>
        <Box
          icon="cool"
          main={[
            {
              textStart: 'Les remboursements aux frais réels',
              textEnd: '',
              type: 'important'
            },
            {
              textStart:
                'Les frais réels correspondent au montant que vous dépensez réellement.',
              textEnd: ''
            }
          ]}
          side={[
            'Envoi de médicaments indispensables et introuvables sur place',
            'Envoi d’un médecin sur place à l’étranger',
            'Transport de l’Assuré au centre médical',
            'Rapatriement de l’Assuré à son domicile',
            'Rapatriement du corps en cas de décès de l’Assuré'
          ]}
        ></Box>
        <Box
          icon="tickets"
          main={[
            {
              textStart: 'Titre de transport aller-retour',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Max. /perso. et /j :',
              textEnd: '50 €'
            },
            {
              textStart: 'Max. :',
              textEnd: '500 €'
            }
          ]}
          side={[
            'Prise en charge d’un titre de transport et des frais de séjour pour un membre de la famille de l’Assuré'
          ]}
        ></Box>
        <Box
          icon="calendar"
          main={[
            {
              textStart: 'Des frais de prolongation de séjour',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Max. /perso. et /j :',
              textEnd: '50 €'
            },
            {
              textStart: 'Max. :',
              textEnd: '500 €'
            },
            {
              textStart: 'Billet aller / retour',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Max. /perso. et /j :',
              textEnd: '50 €'
            },
            {
              textStart: 'Max. :',
              textEnd: '500 €'
            }
          ]}
          side={[
            'Prise en charge des frais de prolongation de séjour de l’Assuré',
            'Retour des accompagnants et prise en charge des frais de séjours'
          ]}
        ></Box>
        <Box
          icon="scales"
          main={[
            {
              textStart: 'Max. par assuré',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Assistance juridique à l’étranger :',
              textEnd: '3 000 €'
            },
            {
              textStart: 'Caution pénale à l’étranger :',
              textEnd: '7 500 €'
            },
            {
              textStart: 'Avance de fonds :',
              textEnd: '500 €'
            }
          ]}
        ></Box>
        <Box
          icon="assistance"
          main={[
            {
              textStart: 'Frais de recherche et de secours',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Max. / assuré :',
              textEnd: '5 000 €'
            },
            {
              textStart: 'Max. :',
              textEnd: '25 000 €'
            }
          ]}
        ></Box>
        <Box
          icon="mountain"
          main={[
            {
              textStart: 'Option assistance',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'sports+ :',
              textEnd: '+10 € / mois'
            }
          ]}
          side={[
            'À souscrire obligatoirement dès 3500 m d’altitude. Les frais de recherche sont +10 € / mois portés à 25 000 €, également pour la pratique de sports dangereux'
          ]}
        ></Box>
      </>
    )
  },
  {
    text: 'Responsabilité civile à l’étranger',
    id: PUBLIC_LIABILITY,
    content: (
      <>
        <Box
          icon="people"
          main={[
            {
              textStart: 'Max. dommages corporels :',
              textEnd: '4 500 000 €',
              type: 'important'
            },
            {
              textStart: 'Max. dommages matériels :',
              textEnd: '450 000 €',
              type: 'important'
            },
            {
              textStart: 'Franchise / sinistre :',
              textEnd: '80 €'
            }
          ]}
        ></Box>
      </>
    )
  },
  {
    text: 'Perte, vol ou détérioration de bagages',
    id: LUGGAGES,
    content: (
      <Box
        icon="luggages"
        main={[
          {
            textStart: 'Max. / assuré / an :',
            textEnd: '2000 €',
            type: 'important'
          },
          {
            textStart: 'Limitation des objets de valeur :',
            textEnd: '1000 €'
          },
          {
            textStart: 'Franchise par dossier :',
            textEnd: '15 €'
          }
        ]}
      ></Box>
    )
  },
  {
    text: 'Capital décès/Garantie individuelle accident',
    id: DEATH,
    content: (
      <>
        <Box
          icon="wheelchair"
          main={[
            {
              textStart: 'Invalidité permanente suite accident',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Par assuré :',
              textEnd: 'jusqu’à 40 000 €'
            }
          ]}
          side={['Franchise relative en cas d’invalidité : 30%']}
        ></Box>
        <Box
          icon="heart"
          main={[
            {
              textStart: 'Décès accidentel',
              textEnd: '',
              type: 'important'
            },
            {
              textStart: 'Par assuré :',
              textEnd: '8 000 €'
            }
          ]}
        ></Box>
      </>
    )
  }
];

const Garanties = ({ profile, aCountries, cCountries }) => {
  return (
    <>
      <Header className={headerStyle.className} profile={profile} />
      <h1 className="sr-only">Les garanties de yupwego</h1>
      <div className="wrapper">
        <Tips
          side
          items={[
            {
              icon: 'icon--hopital',
              text: 'Frais médicaux',
              href: MEDICAL
            },
            {
              icon: 'icon--assistance',
              text: 'Assistance Rapatriement',
              href: SUPPORT_RECOVERY
            },
            {
              icon: 'icon--people',
              text: 'Responsabilité Civile',
              href: PUBLIC_LIABILITY
            },
            {
              icon: 'icon--luggages',
              text: 'Biens nomades et bagages',
              href: LUGGAGES
            }
          ]}
        ></Tips>
        <div className="container notice-container">
          <Card className={noticeCardStyle.className}>
            <p className="text-emphasis card-emphasis">
              Frais médicaux Monde entier jusqu’à 1&nbsp;000&nbsp;000&nbsp;€ et
              prise en charge directe en cas d’hospitalisation, sans avance de
              frais.
            </p>
          </Card>
        </div>
        {cardItems.map(item => (
          <Card
            id={item.id}
            className={boxCardStyle.className}
            key={item.id}
            squared
          >
            <h2 className="box-title">{item.text}</h2>
            {item.content}
          </Card>
        ))}

        <div className="subscription-bottom">
          <Link href={SUBSCRIBE_HREF}>
            <Button
              href={SUBSCRIBE_HREF}
              className={classnames(
                bannerButtonStyle.className,
                'banner-button'
              )}
            >
              Souscrire
            </Button>
          </Link>
          <Link href={SIMULATION_HREF}>
            <Button
              secondary
              href={SIMULATION_HREF}
              className={classnames(
                bannerButtonStyle.className,
                'banner-button'
              )}
            >
              Simuler un prix
            </Button>
          </Link>
        </div>
        <Tips
          centered
          items={[
            {
              icon: 'icon--three-fingers',
              texts: {
                em: [
                  'Durée illimitée, sans engagement',
                  'Toute nature de séjour'
                ]
              }
            },
            {
              icon: 'icon--planet',
              texts: {
                em: ['Destination monde entier'],
                p: [
                  'Sauf : Syrie, Soudan, Cuba, Iran, Corée du nord, Région de la Crimée'
                ]
              }
            },
            {
              icon: 'icon--hey',
              texts: {
                em: [
                  'Souscription < 65 ans',
                  'Pour les enfants accompagnants : tarif préférentiel < 20 ans'
                ],
                p: []
              }
            }
          ]}
        ></Tips>
        <section className="contract" id="contract">
          <div className="contract-item contract-zones-container">
            <div className="contract-zones">
              <p className="contract-emphasis text-emphasis">
                Les zones A, B et C sont déterminées en fonction de plusieurs
                critères notamment le montant des frais d’hospitalisation et
                médicaux sur place.
              </p>
              <p>
                La cotisation est versée en avance toutes les semaines (7
                jours). En cas de changement de zone ou de retour les jours non
                assurés sont remboursés.
              </p>
              <p>
                En bref, vous ne payez jamais pour une couverture dont vous
                n’avez pas besoin.
              </p>
              <h3 id={AREA_A} className="contract-item-title">
                Zone A{' '}
                <span className="contract-item-price">
                  cotisation à partir de 1 € / jour / pers (selon l’âge).
                </span>
              </h3>
              <p className="contract-payment">
                Pays dans lesquels la carte vitale européenne de l’assuré est
                valide:
              </p>
              <p>{aCountries.join(', ')}</p>
              <h3 id={AREA_B} className="contract-item-title">
                Zone B{' '}
                <span className="contract-item-price">
                  cotisation à partir de 1,50 € / jour / pers (selon l’âge).
                </span>
              </h3>
              <p>Tous les autres pays en dehors des pays de la Zone A et C.</p>
              <h3 id={AREA_C} className="contract-item-title">
                Zone C{' '}
                <span className="contract-item-price">
                  cotisation à partir de 2 € / jour / pers (selon l’âge).
                </span>
              </h3>
              <p>Pays dans lesquels les frais peuvent être très élevés:</p>
              <p className="contract-payment">{cCountries.join(', ')}</p>
              <h3 className="contract-item-title">Pays non assurables</h3>
              <p>
                En raison d’embargos internationaux ou de guerres actives les
                garanties ne sont pas applicables aux pays suivants:
              </p>
              <p className="contract-payment">
                Syrie, Soudan, Cuba, Iran, Corée du nord, Région de la Crimée
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      {headerStyle.styles}
      {contractCardStyle.styles}
      {noticeCardStyle.styles}
      {boxCardStyle.styles}
      {bannerButtonStyle.styles}
      <style jsx>{styles}</style>
    </>
  );
};

export default Garanties;
